export const getBaseURL = () => {
  return "/";
};
